export const getBaseURL = () => {
  return "/";
};
